import React from 'react';
import ReactDOM from 'react-dom';
import Notification from './notification';

function createNotification() {
	const div = document.createElement('div');
	div.className = 'component-toast-box';
	document.getElementById('scale-wrapper').appendChild(div);
	return {
		renderNotice(notice) {
			ReactDOM.render(<Notification {...notice}/>, div);
		},
		destroy() {
			ReactDOM.unmountComponentAtNode(div);
			document.body.removeChild(div);
		}
	};
}

let notification,saveOptions;
/**
 *
 * @param options
 * @returns {*|void}
 *
 * [options value]
 * {type, content, duration = 2000, onClose}
 */
const notice = (options) => {
	if (!notification) notification = createNotification();
	options.type = 'show';
	options.keyTime = `notice_${new Date().getTime()}`;
	saveOptions = options;
	return notification.renderNotice(options);
};
const hide = () => {
	let options = saveOptions || {};
	if (!notification) notification = createNotification();
	options.type = 'hide';
	options.keyTime = `notice_${new Date().getTime()}`;
	return notification.renderNotice(options);
};
const destroy = () => {
	notification && notification.destroy();
};

export default {
	notice,
	hide,
	destroy
};



// WEBPACK FOOTER //
// ./src/components/public/toast/index.js